import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "MODULES/parts/actions";
import { AutoComplete } from "MODULES/shared/components";
import * as FormTypes from "MODULES/shared/components/Forms/FormTypes";
import classNames from "classnames";

export function Search({
  search,
  partNumber,
  label,
  alternate_part_id: alternateId
}) {
  const onSelect = (result, _val) => {
    const id = result ? result.id : null;
    alternateId.input.onChange(id);
    alternateId.input.onBlur(id);

    const val = result instanceof Object ? null : result;

    label.input.onChange(val);
    label.input.onBlur(val);
  };

  const touched = alternateId.meta.touched || label.meta.touched;
  const invalid = alternateId.meta.invalid || label.meta.invalid;

  const errorClasses = classNames({ "has-error": touched && invalid });

  return (
    <div className="form-group">
      <label htmlFor="alternate">
        Alternate
        <sup className="small text-danger">*</sup>
      </label>
      <div id="alternate" className="input-group">
        <span className="input-group-addon">
          Part #{partNumber}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <i className="fa fa-exchange" />
        </span>
        <div className={errorClasses}>
          <AutoComplete
            search={search}
            hasId={alternateId.input.value}
            onSelect={onSelect}
            format={result => result.part_number}
            allowUserInput
            autoFocus
          />
        </div>
      </div>
    </div>
  );
}

const formInput = PropTypes.shape({
  input: FormTypes.stringInput.isRequired,
  meta: FormTypes.meta.isRequired
});

Search.propTypes = {
  partNumber: PropTypes.string.isRequired,
  label: formInput.isRequired,
  alternate_part_id: formInput.isRequired,
  search: PropTypes.func.isRequired
};

export default connect(
  state => ({
    partNumber: state.partDetail.getIn(["part", "part_number"])
  }),
  dispatch => ({
    search: filter => dispatch(actions.searchParts(filter))
  })
)(Search);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Alternates/Search.jsx